<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MxrjuV/tc-custom/9781504028165.jpg?1705778252893" alt="This image is the cover for the book Murders & Acquisitions, The Reuben Frost Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murders & Acquisitions, The Reuben Frost Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>During a weekend in the country, Reuben Frost investigates the murder of a frozen-food king who got himself into hot water</b><br/>  <br/> Reuben Frost misses a lot of things about life as a corporate lawyer, but working for Andersen Foods Corporation is not one of them. A vast international enterprise, AFC has made millions pumping out cheap, inoffensive food. But Reuben Frost, a titan of Wall Street, is simply not the TV-dinner type. Unfortunately, even after retiring from the respected law firm Chase &amp; Ward, Frost is still expected to attend the annual Andersen family retreat, a weekend of fun and games as bland as an Andersen frozen meal. This year, however, the retreat will be a bloody good time.<br/>  <br/> A corporate raider has his eyes on the Andersen family fortune, and old Flemming Andersen is determined to fight him to the death—a wish he’ll get to fulfill all too soon. When Andersen is boiled alive in his hot tub, Frost must find the killer to save the corporation and rescue his long weekend.<br/>  <br/><i>Murders &amp; Acquisitions </i>is the 3rd book in the Reuben Frost Mysteries, but you may enjoy reading the series in any order.<br/>  <br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Haughton Murphy
      </h2>
      
      <p class="authorDescription body article">Haughton Murphy is the pseudonym of former lawyer James H. Duffy, author of the Reuben Frost Mysteries. A graduate of Princeton University and Harvard Law School, Duffy got his start writing as a part-time and summer reporter for the <I>Daily Times</I> of Watertown, New York, before moving to New York City to practice law. After a number of years as an attorney, Duffy began writing thrillers, eventually retiring to focus on his novels full-time.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d3539070